/**
 * @generated SignedSource<<9f79b23eba5f80638ec32194d4673204>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CopilotSettingsUserFilterUserOption$data = {
  readonly email: string;
  readonly fullName: string;
  readonly id: string;
  readonly image: string;
  readonly isGuest: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"CopilotSettingsUserFilter" | "RuleConfigurationStepUserPill" | "UserSelectionStepGetIncludesString">;
  readonly " $fragmentType": "CopilotSettingsUserFilterUserOption";
};
export type CopilotSettingsUserFilterUserOption$key = {
  readonly " $data"?: CopilotSettingsUserFilterUserOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"CopilotSettingsUserFilterUserOption">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CopilotSettingsUserFilterUserOption",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGuest",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CopilotSettingsUserFilter"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserSelectionStepGetIncludesString"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RuleConfigurationStepUserPill"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7658b24e3e2fc12e3a879eaa642f11ff";

export default node;
